module.exports = __webpack_public_path__ + "img/37.c89fd396.jpg";